module.exports = __webpack_public_path__ + "static/media/icon-close.919ab92a.svg";